import React, { useState, useEffect } from "react";
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import style from "./Nitrato.module.css";
import modal2 from "./Modal2.module.css";
import Popa from "./Popa.png";
import Proa from "./Proa.png";
import { SnackbarProvider, useSnackbar } from "notistack";

const Nitrato = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [list, setList] = useState([]);
  const [totalData, setTotalData] = useState({});
  const [listaDeObjetos, setListaDeObjetos] = useState([]);
  const [pedidos, setPedidos] = useState([]); // Adicionando estado para pedidos
  const [moegaView, setMoegaView] = useState(true);
  const [acordeaoAberto, setAcordeaoAberto] = useState(null);
  const [poraoData, setPoraoData] = useState([]); // Inicializa como um array vazio
  const [numeroPoroes, setNumeroPoroes] = useState(0);
  const [poraoDescarregado, setPoraoDescarregado] = useState([]); // Inicializa como um array vazio
  const [selectedNavio, setSelectedNavio] = useState("");
  const [processedData, setProcessedData] = useState({}); // Estado para armazenar os dados processados
  const [isIntegrating, setIsIntegrating] = useState(false);
  const [countdown, setCountdown] = useState(30);

  const { id } = useParams();
  const navigate = useNavigate();

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  // Função para alternar o acordeão
  const toggleAcordeao = (indiceDoc) => {
    if (acordeaoAberto === indiceDoc) {
      setAcordeaoAberto(null); // Fecha o acordeão se já estiver aberto
    } else {
      setAcordeaoAberto(indiceDoc); // Abre o acordeão para o documento atual
    }
  };

  const getPoraoData = (codOperacao) => {
    Axios.get(`https://operacao.setlogistica.com.br/api/porao/${codOperacao}`)
      .then((response) => {
        if (response.data) {
          console.log("Dados recebidos do porão:", response.data); // Adiciona o log aqui
          setPoraoData(response.data[0]); // Armazena os dados no estado poraoData (note que estou pegando o primeiro item do array)
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados do Porão:", error);
      });
  };

  const getCargoHolds = async (codOperacao) => {
    try {
      const response = await Axios.get(
        `https://operacao.setlogistica.com.br/api/operacao/${codOperacao}/cargo-holds`
      );
      if (response.status === 200) {
        const { CARGO_HOLDS, NOME_NAVIO } = response.data;
        setNumeroPoroes(CARGO_HOLDS);
        setSelectedNavio(NOME_NAVIO);
      } else {
        showAlert("Erro ao carregar informações do navio.", "error");
      }
    } catch (error) {
      showAlert("Erro ao carregar informações do navio.", "error");
      console.error(error);
    }
  };

  const getPoraoDescarregado = (codOperacao) => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/porao/descarregado/${codOperacao}`
    )
      .then((response) => {
        if (response.data) {
          console.log("Dados recebidos do porão:", response.data); // Verifique se os dados estão sendo recebidos corretamente
          setPoraoDescarregado(response.data); // Salve os dados recebidos no estado
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados do Porão:", error);
      });
  };

  useEffect(() => {
    if (id) {
      getPoraoDescarregado(id); // Usa id como código da operação para buscar dados
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      getPoraoData(id); // Usa id como código da operação para buscar dados
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      getCargoHolds(id); // Usa id como código da operação para buscar dados de porões e nome do navio
    }
  }, [id]);

  const processData = (data) => {
    return data.reduce((acc, item) => {
      console.log("Processando item:", item); // Verifique se o item contém QTDE_MANIFESTADA e DESCARREGADO_CARGA

      if (!acc[item.NUMERO_DOC]) {
        acc[item.NUMERO_DOC] = [];
      }
      acc[item.NUMERO_DOC].push(item);
      return acc;
    }, {});
  };

  // Função para buscar dados da API
  async function fetchData() {
    try {
      const [response, totalResponse, graficResponse, pedidosResponse] =
        await Promise.all([
          Axios.get(`https://operacao.setlogistica.com.br/api/grafico/${id}`),
          Axios.get(
            `https://operacao.setlogistica.com.br/api/grafico/total/${id}`
          ),
          Axios.get(
            `https://operacao.setlogistica.com.br/api/graficdocs/${id}`
          ),
          Axios.get(
            `https://operacao.setlogistica.com.br/api/graficdocs/pedido/${id}`
          ),
        ]);

      console.log("Dados de graficdocs:", graficResponse.data); // Verifique se QTDE_MANIFESTADA e DESCARREGADO estão aqui

      setList(response.data);
      setTotalData(totalResponse.data);
      setListaDeObjetos(processData(graficResponse.data));
      setPedidos(pedidosResponse.data);
    } catch (error) {
      console.error("Erro ao buscar os dados: ", error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [id]);

  const toggleView = () => {
    setMoegaView(!moegaView);
  };

  // Função para filtrar pedidos relacionados ao documento
  const getPedidosForDoc = (codCarga) => {
    const pedidosRelacionados = pedidos.filter(
      (pedido) => pedido.COD_CARGA === codCarga
    );
    console.log(
      `Pedidos relacionados ao COD_CARGA ${codCarga}:`,
      pedidosRelacionados
    ); // Verificar pedidos filtrados
    return pedidosRelacionados;
  };

  const formattedData = {
    totalManifestado: (totalData.TOTAL_MANIFESTADO / 1000).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      }
    ),
    totalDescarregado: (totalData.TOTAL_PESO_CARREGADO / 1000).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      }
    ),
    saldo: (
      (totalData.TOTAL_MANIFESTADO - totalData.TOTAL_PESO_CARREGADO) /
      1000
    ).toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    }),
    porcentagemCarregada: totalData.PORCENTAGEM_PESO_CARREGADO_MOEGA,
  };

  const PorcentagemBar = ({ porcentagem }) => (
    <div className={style.grbackbar}>
      <div
        className={`${style.grBar} ${porcentagem >= 90 ? style.grred : style.grblue
          }`}
        style={{ width: `${porcentagem}%` }}
      >
        <span className={style.percentText}>{porcentagem}%</span>
      </div>
    </div>
  );

  const processProductData = (data) => {
    return data.reduce((acc, item) => {
      const nomeProduto = item.NOME_PRODUTO;

      if (!acc[nomeProduto]) {
        acc[nomeProduto] = {
          NOME_PRODUTO: nomeProduto,
          TOTAL_MANIFESTADO: 0,
          TOTAL_DESCARREGADO: 0,
        };
      }

      acc[nomeProduto].TOTAL_MANIFESTADO += item.MANIFESTADO_NUMERO_DOC || 0;
      acc[nomeProduto].TOTAL_DESCARREGADO += item.DESCARREGADO_NUMERO_DOC || 0;

      return acc;
    }, {});
  };

  useEffect(() => {
    // Quando listaDeObjetos for atualizada, processar os dados
    const processed = processProductData(Object.values(listaDeObjetos).flat());
    setProcessedData(processed);
  }, [listaDeObjetos]);

  const handleIntegrarMicSistemas = async () => {
    setIsIntegrating(true);
    setCountdown(70); // Inicia a contagem regressiva de 70 segundos
    localStorage.setItem("isIntegrating", true);
    localStorage.setItem("countdown", 70);

    // Iniciar a contagem regressiva imediatamente após o clique
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => {
        const newCountdown = prevCountdown - 1;
        localStorage.setItem("countdown", newCountdown);

        if (newCountdown <= 0) {
          clearInterval(interval);
          localStorage.removeItem("isIntegrating");
          localStorage.removeItem("countdown");
          window.location.reload(); // Atualiza a página após a contagem regressiva
          return 0;
        }
        return newCountdown;
      });
    }, 1000);

    try {
      // Usar o 'id' que já foi extraído dos parâmetros da URL
      const micResponse = await Axios.post(
        "https://operacao.setlogistica.com.br/api/puppeteer/micsistemas",
        { codOperacao: id } // Envie o COD_OPERACAO atual
      );

      if (micResponse.status === 200) {
        showAlert("Integração com MIC Sistemas iniciada com sucesso!", "success");

        // Após a integração com MIC Sistemas, avançar imediatamente para a integração com Transportadora
        const transportadoraResponse = await Axios.post(
          "https://operacao.setlogistica.com.br/api/integracaomic/transportadora",
          { codOperacao: id } // Envie o mesmo COD_OPERACAO
        );

        if (transportadoraResponse.status === 200) {
          showAlert(
            "Integração com transportadora concluída com sucesso!",
            "success"
          );
        } else {
          showAlert("Erro ao integrar com transportadora.", "error");
          clearInterval(interval);
          return;
        }
      } else {
        showAlert("Erro ao integrar com MIC Sistemas.", "error");
        clearInterval(interval);
        return;
      }

      // Se ambas as integrações foram concluídas com sucesso, atualiza a página
      clearInterval(interval);
      localStorage.removeItem("isIntegrating");
      localStorage.removeItem("countdown");
      window.location.reload();
    } catch (error) {
      console.error("Erro ao executar as integrações:", error);
      showAlert("Erro ao executar as integrações.", "error");
      clearInterval(interval);
      localStorage.removeItem("isIntegrating");
      localStorage.removeItem("countdown");
    }
  };


  useEffect(() => {
    const savedIsIntegrating = localStorage.getItem("isIntegrating") === "true";
    const savedCountdown = parseInt(localStorage.getItem("countdown"), 10);

    if (savedIsIntegrating && savedCountdown > 0) {
      setIsIntegrating(true);
      setCountdown(savedCountdown);

      const interval = setInterval(() => {
        setCountdown((prevCountdown) => {
          const newCountdown = prevCountdown - 1;
          localStorage.setItem("countdown", newCountdown);

          if (newCountdown <= 0) {
            clearInterval(interval);
            localStorage.removeItem("isIntegrating");
            localStorage.removeItem("countdown");
            window.location.reload(); // Atualiza a página após a contagem regressiva
            return 0;
          }
          return newCountdown;
        });
      }, 1000);

      return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
    }
  }, []);

  // Função utilitária (adicione antes do return do JSX):
const formatIdx = (i) => (i + 1 < 10 ? `0${i + 1}` : `${i + 1}`);

  return (
    <>
      <Navbar operacao />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacoes`)}
            >
              Operações
            </div>
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/${id}`)}
            >
              Pesagem Funil
            </div>
            {/* <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/pesagemfinal/${id}`)}
            >
              Pesagem de Conferência
            </div> */}
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/relatorioautosaberto/${id}`)}
            >
              Autos Em Aberto
            </div>
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/${id}/AberturaPeriodo`)}
            >
              Abertura de Período
            </div>
            <div className={style.navItemActive}>{">"} DashBoard</div>
          </div>

          <div className={style.gftitle}>
            <b>Controle Geral ({totalData.NOME_NAVIO})</b>
          </div>
          <table className={style.gfTable}>
            <thead>
              <tr>
                <th>Porcentagem Carregada</th>
                <th>Manifestado</th>
                <th>Descarregado</th>
                <th>Saldo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Porcentagem Carregada">
                  <PorcentagemBar
                    porcentagem={formattedData.porcentagemCarregada}
                  />
                </td>
                <td data-label="Manifestado" style={{ textAlign: "left" }}>
                  {formattedData.totalManifestado}
                </td>
                <td data-label="Descarregado" style={{ textAlign: "left" }}>
                  {formattedData.totalDescarregado}
                </td>
                <td data-label="Saldo" style={{ textAlign: "left" }}>
                  {formattedData.saldo}
                </td>
              </tr>
            </tbody>
          </table>

          <div className={style.gftitle}>
            <b>Quantidade por Produto</b>
          </div>

          <table className={style.gfTable}>
            <thead>
              <tr>
                <th>Produto</th>
                <th>Manifestado</th>
                <th>Descarregado</th>
                <th>Saldo</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(processedData).map(([nomeProduto, produto]) => {
                const saldo = (
                  (produto.TOTAL_MANIFESTADO - produto.TOTAL_DESCARREGADO) /
                  1000
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                });

                return (
                  <tr key={nomeProduto}>
                    <td data-label="Produto">{produto.NOME_PRODUTO}</td>
                    <td data-label="Manifestado" style={{ textAlign: "left" }}>
                      {(produto.TOTAL_MANIFESTADO / 1000).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 3, maximumFractionDigits: 3 }
                      )}
                    </td>
                    <td data-label="Descarregado" style={{ textAlign: "left" }}>
                      {(produto.TOTAL_DESCARREGADO / 1000).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3,
                        }
                      )}
                    </td>
                    <td data-label="Saldo" style={{ textAlign: "left" }}>
                      {saldo}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className={style.gftitle}>
            <b>Quantidade descarregada por (DI)</b>
          </div>

          <table className={style.gfTable}>
            <thead>
              <tr>
                <th>Produto</th>
                <th>Manifestado DI</th>
                <th>Descarregado DI</th>
                <th>Saldo DI</th>
                <th>DI</th>
                <th>Pedido</th>
                <th>Manifestado Pedido</th>
                <th>Descarregado Pedido</th>
                <th>Saldo Pedido</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(listaDeObjetos).map(
                ([numeroDoc, dados], indiceDoc) => {
                  const totalManifestado = dados.reduce(
                    (acc, pedido) => acc + (pedido.MANIFESTADO_NUMERO_DOC || 0),
                    0
                  );
                  const totalDescarregado = dados.reduce(
                    (acc, pedido) =>
                      acc + (pedido.DESCARREGADO_NUMERO_DOC || 0),
                    0
                  );
                  const saldoDI = (
                    (totalManifestado - totalDescarregado) /
                    1000
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 3,
                    maximumFractionDigits: 3,
                  });
                  const codCarga = dados[0].COD_CARGA;
                  const nomeProduto = dados[0].NOME_PRODUTO; // Obtém o nome do produto para o documento
                  const pedidosRelacionados = getPedidosForDoc(codCarga);

                  return (
                    <React.Fragment key={indiceDoc}>
                      {pedidosRelacionados.length > 0 ? (
                        pedidosRelacionados.map((pedido, indicePedido) => {
                          const saldoPedido = (
                            (pedido.QTDE_MANIFESTADA_PEDIDO -
                              pedido.PESO_LIQUIDO_POR_PEDIDO_MIC) /
                            1000
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          });

                          return (
                            <tr key={`${indiceDoc}-${indicePedido}`}>
                              {indicePedido === 0 && (
                                <>
                                  <td
                                    data-label="Produto"
                                    rowSpan={pedidosRelacionados.length}
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    {nomeProduto}
                                  </td>
                                  <td
                                    data-label="Manifestado DI"
                                    rowSpan={pedidosRelacionados.length}
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "right",
                                    }}
                                  >
                                    {(totalManifestado / 1000).toLocaleString(
                                      undefined,
                                      {
                                        minimumFractionDigits: 3,
                                        maximumFractionDigits: 3,
                                      }
                                    )}
                                  </td>
                                  <td
                                    data-label="Descarregado DI"
                                    rowSpan={pedidosRelacionados.length}
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "right",
                                    }}
                                  >
                                    {(totalDescarregado / 1000).toLocaleString(
                                      undefined,
                                      {
                                        minimumFractionDigits: 3,
                                        maximumFractionDigits: 3,
                                      }
                                    )}
                                  </td>
                                  <td
                                    data-label="Saldo DI"
                                    rowSpan={pedidosRelacionados.length}
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "right",
                                    }}
                                  >
                                    {saldoDI}
                                  </td>
                                  <td
                                    data-label="DI"
                                    rowSpan={pedidosRelacionados.length}
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    <b>{numeroDoc}</b>
                                  </td>
                                </>
                              )}
                              <td data-label="Pedido">
                                {pedido.PEDIDO_MIC || ""} (
                                {pedido.NOME_DESTINO || ""})
                              </td>
                              <td
                                data-label="Manifestado Pedido"
                                style={{ textAlign: "right" }}
                              >
                                {(
                                  pedido.QTDE_MANIFESTADA_PEDIDO / 1000
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 3,
                                  maximumFractionDigits: 3,
                                })}
                              </td>
                              <td
                                data-label="Descarregado Pedido"
                                style={{ textAlign: "right" }}
                              >
                                {(
                                  pedido.PESO_LIQUIDO_POR_PEDIDO_MIC / 1000
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 3,
                                  maximumFractionDigits: 3,
                                })}
                              </td>
                              <td
                                data-label="Saldo Pedido"
                                style={{ textAlign: "right" }}
                              >
                                {saldoPedido}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr key={indiceDoc}>
                          <td data-label="DI">
                            <b>{numeroDoc}</b>
                          </td>
                          <td
                            data-label="Manif. DI Tons"
                            style={{ textAlign: "right" }}
                          >
                            {(totalManifestado / 1000).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3,
                              }
                            )}
                          </td>
                          <td
                            data-label="Desc. DI Tons"
                            style={{ textAlign: "right" }}
                          >
                            {(totalDescarregado / 1000).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3,
                              }
                            )}
                          </td>
                          <td
                            data-label="Saldo DI Tons"
                            style={{ textAlign: "right" }}
                          >
                            {saldoDI}
                          </td>
                          <td data-label="Produto">{nomeProduto}</td>
                          <td colSpan="4" style={{ textAlign: "right" }}>
                            Sem pedidos relacionados
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                }
              )}
            </tbody>
          </table>

          <div className={`${modal2.confirmar} hideOnMobile`}>
            <div className={modal2.confirmar}>
              <div className={modal2.layoutContainer}>
                <div className={modal2.imageWrapperleft}>
                  <img src={Popa} alt="Popa" className={modal2.shipImage} />
                  <table className={modal2.breakdownTable2}>
                    <tbody>
                      <tr>
                        <td>MANIFESTADO</td>
                      </tr>
                      <tr>
                        <td>DESCARREGADO</td>
                      </tr>
                      <tr>
                        <td>SALDO</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className={modal2.tableWrapper}>
<table className={modal2.breakdownTable}>
  <thead>
    <tr>
      {[...Array(numeroPoroes)].map((_, index) => (
        <th key={index}>Porão {index + 1}</th>
      ))}
    </tr>
  </thead>
<tbody>
  {/* Linha de produtos */}
  <tr>
    {[...Array(numeroPoroes)].map((_, index) => {
      const produto =
        poraoData && Array.isArray(poraoData) && poraoData[0]
          ? poraoData[0][`PRODUTO_${formatIdx(index)}`]
          : null;
      return <td key={index}>{produto || "N/A"}</td>;
    })}
  </tr>

  {/* Linha de manifestado */}
  <tr>
    {[...Array(numeroPoroes)].map((_, index) => {
      const manifestado =
        poraoData && Array.isArray(poraoData) && poraoData[0]
          ? poraoData[0][`PORAO_${formatIdx(index)}_MANIFESTADO`] || 0
          : 0;

      return (
        <td key={index}>
          {(manifestado / 1000).toLocaleString("pt-BR", {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          })}
        </td>
      );
    })}
  </tr>

  {/* Linha de descarregado */}
  <tr>
    {[...Array(numeroPoroes)].map((_, index) => {
      const porao = poraoDescarregado.find(
        (p) => p.PORAO === (index + 1).toString()
      );
      const descarregado = porao?.PESO_LIQUIDO_TOTAL || 0;

      return (
        <td key={index}>
          {(descarregado / 1000).toLocaleString("pt-BR", {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          })}
        </td>
      );
    })}
  </tr>

  {/* Linha de saldo */}
  <tr>
    {[...Array(numeroPoroes)].map((_, index) => {
      const manifestado =
        poraoData && Array.isArray(poraoData) && poraoData[0]
          ? poraoData[0][`PORAO_${formatIdx(index)}_MANIFESTADO`] || 0
          : 0;

      const descarregado = poraoDescarregado.find(
        (p) => p.PORAO === (index + 1).toString()
      )?.PESO_LIQUIDO_TOTAL || 0;

      const saldo = manifestado - descarregado;

      return (
        <td key={index}>
          {(saldo / 1000).toLocaleString("pt-BR", {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          })}
        </td>
      );
    })}
  </tr>
</tbody>

</table>
                </div>

                <div className={modal2.imageWrapperright}>
                  <img src={Proa} alt="Proa" className={modal2.shipImage} />
                </div>
              </div>
            </div>
          </div>
          <fieldset className={style.fieldset}>
            <legend className={style.legend}>Comandos Rápidos</legend>
            <div className={modal2.micsistemas}>
              <button
                type="button"
                className={modal2.finalizar}
                onClick={!isIntegrating ? handleIntegrarMicSistemas : null}
                disabled={isIntegrating} // Desabilita o botão enquanto está integrando
              >
                {isIntegrating
                  ? `Aguarde... (${countdown}s)`
                  : "INTEGRAR MIC SISTEMAS"}
              </button>
            </div>
          </fieldset>
        </div>
      </Container>
    </>
  );
};

function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <Nitrato />
    </SnackbarProvider>
  );
}

export default IntegrationNotistack;
